<app-toasts-container></app-toasts-container>
<app-global-spinner></app-global-spinner>
<router-outlet> </router-outlet>